export default __webpack_public_path__ + "static/loading-9931805b6e496810625cc0839e13401b.gif";